export default __webpack_public_path__ + "static/media/100_73403.84aedcd3.jpg";